import type { Delta, Range } from 'quill/core';

function transformRange(range: Range, delta: Delta, priority = false): Range {
  const start = delta.transform(range.index, priority);
  const end = delta.transform(range.index + range.length, priority);
  return {
    index: start,
    length: end - start,
  };
}

export default transformRange;
